
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class FixedRateMasterSelectGrid extends Serenity.EntityGrid<FixedRateMasterRow, any> {
        protected getColumnsKey() { return 'OMS.FixedRateMaster'; }
        protected getDialogType() { return <any>FixedRateMasterDialog; }
        protected getIdProperty() { return FixedRateMasterRow.idProperty; }
        protected getLocalTextPrefix() { return FixedRateMasterRow.localTextPrefix; }
        protected getService() { return FixedRateForFGService.baseUrl; }
        //protected useViewMode() { return true; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            return this;
        }

        get selectedItems(): FixedRateMasterRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideRates && this.options.hideRates.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["RateID" /* RateID */], 'not in', [this.options.hideRates]]);
            return true;

        }

    }

    export interface RateSelectOptions {
        ParentKey?: string;
        Key?: string;
        Title?: string;
        IsGroup?: boolean;
        GrantRevoke?: boolean;
    }
}